import React from 'react';

const PhoneIcon24 = ({ className }) => (
  <svg className={className} height="24" width="24">
    <path d="m6.6200017 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25 1.12.37 2.32.57 3.5699983.57.5500017 0 1 .44 1 1v3.5c0 .55-.4499983 1-1 1-9.3899983 0-17-7.62-17-17-.0009983-.56.4400017-1 1-1h3.5c.5500017 0 1 .44 1 1 0 1.25.2000017 2.45.5700017 3.57.11.35.03.74-.25 1.02z" />
  </svg>
);

export default PhoneIcon24;
